import ContactsPage from '@/pages/contacts/CMContactsPage.vue'
import AddContactGroupPage from '@/pages/contacts/CMAddContactGroup.vue'
import AddContactPage from '@/pages/contacts/CMAddContact.vue'
import EditContactPage from '@/pages/contacts/CMEditContact.vue'
import EditContactGroupPage from '@/pages/contacts/CMEditContactGroup.vue'
import ContactDetail from '@/pages/contacts/CMContactDetail.vue'
import ContactGroupDetail from '@/pages/contacts/CMContactGroupDetail.vue'
import AddContactGroupContactList from '@/pages/contacts/CMAddContactGroupContactList.vue'
import ImportContact from '@/pages/contacts/CMContactsImport.vue'

export default [
  {
    path: '/contacts/',
    alias: ['/account/contacts/'],
    component: ContactsPage
  },
  {
    path: '/account/addContactGroup/',
    component: AddContactGroupPage
  },
  {
    path: '/account/addContact/',
    component: AddContactPage
  },
  {
    path: '/account/editContact/',
    component: EditContactPage
  },
  {
    path: '/account/editContactGroup/',
    component: EditContactGroupPage
  },
  {
    path: '/account/contactDetail/',
    component: ContactDetail
  },
  {
    path: '/account/contactGroupDetail/',
    component: ContactGroupDetail
  },
  {
    path: '/account/addContactGroupContactList/',
    component: AddContactGroupContactList
  },
  {
    path: '/contact/import',
    component: ImportContact
  }
]



// WEBPACK FOOTER //
// ./src/routes/contacts.js